'use strict';

require("core-js/modules/es6.string.repeat");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.replace");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var uuid = require('uuid');

var uuidv1 = require('uuid/v1');

var uuidv4 = require('uuid/v4');

var uuidv5 = require('uuid/v5');

var baseX = require('base-x');

var base62 = baseX('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
var OUTPUT_LENGTH = 22;
var UUID_LENGTH = 32;
var Buffer = global ? global.Buffer : undefined;

if (typeof Buffer === 'undefined') {
  // import buffer module for use in browser - browserify and perhaps webpack
  // should do this automatically, but otherwise we'll pull it in here
  Buffer = require('buffer').Buffer;
}

var UUID62 =
/*#__PURE__*/
function () {
  function UUID62() {
    _classCallCheck(this, UUID62);

    this.base = base62; // expose underlying methods for convenience (matches uuid-base62)

    this.uuid = uuid;
    this.baseX = baseX; // pre-defined v5/v3 namespaces

    this.URL = '3h8Pgc0Wb7WH6HsyG77m40';
    this.DNS = '3h8PgalTIPNcNhUD4ZbIKY';
  }

  _createClass(UUID62, [{
    key: "v4",
    value: function v4() {
      var args = Array.prototype.slice.call(arguments);

      if (!args[1]) {
        // make sure we use a buffer to avoid getting a uuid with dashes
        args[1] = new Buffer(16);
      }

      var id = uuidv4.apply(this, args);
      return this.encode(id);
    }
  }, {
    key: "v5",
    value: function v5() {
      var args = Array.prototype.slice.call(arguments);

      if (typeof args[1] === 'string' && /^[0-9A-Za-z]{22}$/.test(args[1])) {
        args[1] = this.decode(args[1]);
      }

      var id = uuidv5.apply(this, args);
      return this.encode(id);
    }
  }, {
    key: "v1",
    value: function v1() {
      var args = Array.prototype.slice.call(arguments);

      if (!args[1]) {
        // make sure we use a buffer to avoid getting a uuid with dashes
        args[1] = new Buffer(16);
      }

      var id = uuidv1.apply(this, args);
      return this.encode(id);
    }
  }, {
    key: "encode",
    value: function encode(input, encoding) {
      encoding = encoding || 'hex';

      if (typeof input === 'string') {
        // remove the dashes to save some space
        input = new Buffer(input.replace(/-/g, ''), encoding);
      }

      return ensureLength(this.base.encode(input), OUTPUT_LENGTH);
    }
  }, {
    key: "decode",
    value: function decode(input, encoding) {
      encoding = encoding || 'hex';
      var res = ensureLength(new Buffer(this.base.decode(input)).toString(encoding), UUID_LENGTH); // insert dashes on return

      return "".concat(res.slice(0, 8), "-").concat(res.slice(8, 12), "-").concat(res.slice(12, 16), "-").concat(res.slice(16, 20), "-").concat(res.slice(20));
    }
  }, {
    key: "customBase",
    get: function get() {
      return this.base;
    },
    set: function set(base) {
      this.base = base;
    }
  }, {
    key: "length",
    get: function get() {
      return OUTPUT_LENGTH;
    }
  }, {
    key: "uuidLength",
    get: function get() {
      return UUID_LENGTH;
    }
  }]);

  return UUID62;
}();

function ensureLength(input, targetLength) {
  input = input.toString();
  return "".concat('0'.repeat(32)).concat(input).slice(-targetLength);
}

module.exports = new UUID62();